import { http } from "@/communication";
import { moduleFactory } from "@/store/resource";

const resourceModule = moduleFactory("dialog");
resourceModule.actions.newTempDialog = async ({ commit }, partnerId) => {
  if (!partnerId) return;

  const { data } = await http.get("api/v1/customerProfile", {
    params: {
      filter: [
        {
          name: "where",
          attributes: {
            id: partnerId
          }
        }
      ]
    }
  });

  if (data.length) {
    commit("create", data[0]);
    return data[0];
  }
};

export const dialogModule = resourceModule;
